import React, { Component, PropTypes } from 'react';
import { RadioButtonGroup, RadioButton, Input } from 'sabre-spark-react';
import { debounce } from 'lodash';
import ConfigSearchProvider from './provider/ConfigSearchProvider';
import Store from '../../../../store/Store';
import ModalConfirmationSettings from '../../../modals/ModalConfirmationSettings';
import { LanguageSelect } from './labels/language-select';
import { connect } from 'react-redux';
import LabelsSearchProvider from './provider/LabelsSearchProvider';
import PagesTrackingHooks from '../PagesTrackingHooks';
import { checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../../../../src/constants/AccessPoints';
import If from '../../../helpers/if';
import get from 'lodash/get';

class PageSearchConfig extends Component {
    static defaultProps = {
        languageList: []
    };

    constructor(props) {
        super(props);
        this.state = {
            search: '',
            searchMode: this.selectDefaultSearchType(),
            languages: [],
            selectedTab: 'hosted'
        };
        this.onModeChange = this.onModeChange.bind(this);
        this.onSearch = debounce(this.onSearch.bind(this), 400);
        this.onTabChange = this.onTabChange.bind(this);
    }

    onTabChange(tabName) {
        this.setState({
            selectedTab: tabName
        });
    }

    onModeChange(value) {
        this.setState({
            searchMode: value
        });
    }

    onSearch(value) {
        this.setState({
            search: value
        });
    }

    selectDefaultSearchType() {
        if (
            this.props.hasAccessConfiguration.view ||
            this.props.hasAccessConfiguration.edit ||
            this.props.hasAccessTrackingHooks.view ||
            this.props.hasAccessTrackingHooks.edit
        ) {
            return ACCESS_POINTS_GROUP.CONFIGURATION;
        } else {
            return ACCESS_POINTS_GROUP.LABELS;
        }
    }

    hasAccessToType(typeName) {
        if (typeName === ACCESS_POINTS_GROUP.CONFIGURATION) {
            return (
                this.props.hasAccessConfiguration.view ||
                this.props.hasAccessConfiguration.edit ||
                this.props.hasAccessTrackingHooks.view ||
                this.props.hasAccessTrackingHooks.edit
            );
        } else if (typeName === ACCESS_POINTS_GROUP.LABELS) {
            return this.props.hasAccessLabels.view || this.props.hasAccessLabels.edit;
        }
    }

    render() {
        return (
            <div>
                <h2>Search</h2>
                <div className="row spark-mar-b-2">
                    <div className="col-xs">
                        <RadioButtonGroup onChange={this.onModeChange}>
                            <RadioButton
                                disabled={!this.hasAccessToType(ACCESS_POINTS_GROUP.CONFIGURATION)}
                                name="search-mode"
                                value="config"
                                checked={this.state.searchMode === ACCESS_POINTS_GROUP.CONFIGURATION}
                                onClick={() => this.onModeChange(ACCESS_POINTS_GROUP.CONFIGURATION)}
                            >
                                In Configuration
                            </RadioButton>
                            <RadioButton
                                disabled={!this.hasAccessToType(ACCESS_POINTS_GROUP.LABELS)}
                                name="search-mode"
                                value="labels"
                                checked={this.state.searchMode === ACCESS_POINTS_GROUP.LABELS}
                                onClick={() => this.onModeChange(ACCESS_POINTS_GROUP.LABELS)}
                            >
                                In Labels
                            </RadioButton>
                        </RadioButtonGroup>
                    </div>
                    {this.state.searchMode === ACCESS_POINTS_GROUP.LABELS && (
                        <div className="col-xs-8">
                            <LanguageSelect
                                onChange={languages => {
                                    this.setState({
                                        languages: languages
                                    });
                                }}
                            />
                        </div>
                    )}
                </div>
                <div className="row spark-mar-b-2">
                    <div className="col-xs">
                        <Input
                            label="Search Criteria"
                            defaultValue={this.state.search}
                            onChange={value => {
                                this.onSearch(value);
                            }}
                        />
                    </div>
                </div>
                <div className="row spark-mar-b-2">
                    {this.state.searchMode === ACCESS_POINTS_GROUP.CONFIGURATION && (
                        <div className="col-xs">
                            <ConfigSearchProvider
                                search={this.state.search}
                                hasAccessConfiguration={this.props.hasAccessConfiguration}
                                hasAccessTrackingHooks={this.props.hasAccessTrackingHooks}
                            >
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Products"
                                    location="pages/product/settings"
                                    component="rooms"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Confirmation"
                                    location="pages/confirmation/settings"
                                    component="confirmation"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Guest & payment"
                                    location="pages/guest-payment/information/settings"
                                    component="guestInfo"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    location="pages/calendar/settings"
                                    pageTitle="Calendar"
                                    component="calendar"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Global bar"
                                    location="pages/globalBar/settings"
                                    component="globalBar"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Filters"
                                    location="pages/filters/settings"
                                    component="filters"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="Hotel"
                                    location="pages/hotel/settings"
                                    component="hotel"
                                />
                                <ModalConfirmationSettings
                                    store={Store}
                                    pageTitle="General"
                                    location="pages/general/settings"
                                    component="general"
                                />
                                <PagesTrackingHooks pageTitle="Tracking hooks" />
                            </ConfigSearchProvider>
                        </div>
                    )}
                    {this.state.searchMode === ACCESS_POINTS_GROUP.LABELS && (
                        <div className='col-xs'>
                            <If condition={this.props.inContextBeta}>
                                <nav className="spark-tabs__nav" role="menubar">
                                    <div className="spark-tabs__scroll">
                                        <ul className="spark-tabs__list" role="tablist">
                                            <li
                                                className={`spark-tabs__tab text-center ${this.state.selectedTab === 'hosted' ? 'active' : ''}`}
                                                role="tab"
                                                onClick={() => this.onTabChange('hosted')}
                                            >
                                                <a>Hosted</a>
                                            </li>
                                            <li
                                                className={`spark-tabs__tab text-center ${this.state.selectedTab === 'in-context' ? 'active' : ''}`}
                                                role="tab"
                                                onClick={() => this.onTabChange('in-context')}
                                            >
                                                <a>In-context</a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </If>
                            <LabelsSearchProvider
                                hasAccess={this.props.hasAccessLabels}
                                search={this.state.search}
                                languages={this.state.languages}
                                selectedTab={this.state.selectedTab}
                                inContextBeta={this.props.inContextBeta}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode,
        hasAccessLabels: checkPermissions(state, ACCESS_POINTS_GROUP.LABELS),
        hasAccessConfiguration: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        hasAccessTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS),
        inContextBeta: get(state, 'app.selected.inContextBeta')
    };
};

export default connect(mapStateToProps)(PageSearchConfig);



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/PageSearchConfig.js